import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '../pages/HomePage.vue';

const routes = [
  { path: '/', component: HomePage },
  // 예전 주소 호환 → 같은 페이지의 해당 위치로
  { path: '/about', redirect: { path: '/', hash: '#about' } },
  { path: '/business', redirect: { path: '/', hash: '#business' } },
  { path: '/technology', redirect: { path: '/', hash: '#business' } },
  { path: '/partners', redirect: { path: '/', hash: '#partners' } },
  { path: '/history', redirect: { path: '/', hash: '#partners' } },
  { path: '/contact', redirect: { path: '/', hash: '#contact' } },
  { path: '/:pathMatch(.*)*', redirect: '/' },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    if (to.hash) return false; // HomePage가 직접 처리
    return { top: 0 };
  },
});

export default router;
